module.exports = __webpack_public_path__ + "238acfeddad25ea008dd3929947aac1a.woff2";